module.exports = __webpack_public_path__ + "static/media/charity.1ab2c0f9.svg";